<template>
  <div id="home" :class="{ 'no-header': noHeader }">
    <!-- 头部导航：移动端视口统一使用 H5 头部（搜索 / 头像 / 菜单），桌面端保持原 PC 头部 -->
    <h5-header v-if="showMobileHeader" />
    <headerComponent v-else-if="!noHeader" />
    <router-view></router-view>
  </div>
</template>


<script>
import Header from "./components/header/index.vue";
import H5Header from "./components/h5Header/index.vue";
import api from "@/api/index";

// 移动端视口断点：与首页跳转 H5 的判定保持一致（<768 视为移动端）
const MOBILE_MAX_WIDTH = 768;

export default {
  name: "App",
  components: {
    headerComponent: Header,
    h5Header: H5Header,
  },

  data() {
    return {
      // 当前视口是否为移动端（随窗口尺寸变化实时更新）
      isMobileView: false,
    };
  },

  computed: {
    // OAuth 独立路由体系：不展示主站 header
    isOauthRoute() {
      return this.$route.path.startsWith("/oauth");
    },
    // OAuth 路由及首页（设计稿自带头部）均不展示主站 header
    noHeader() {
      return this.isOauthRoute || this.$route.meta.noHeader === true;
    },
    // 移动端头部：仅在无自有头部的页面接管，避免与首页/H5 首页/登录页既有布局重复
    showMobileHeader() {
      return this.isMobileView && !this.noHeader;
    },
  },

  methods: {
    // 同步视口断点（挂载时执行一次，resize 时实时切换头部组件）
    syncViewport() {
      this.isMobileView = window.innerWidth < MOBILE_MAX_WIDTH;
    },
    // 获取用户信息
    getUserCenterInfo() {
      api.getUserCenterInfo().then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.$store.dispatch("setUserinfo", data);
        } else {
          if (this.$route.path !== "/login") {
            this.$store.dispatch("clearUserinfo");
          }
        }
      });
    },
  },

  created() {
    // this.getUserCenterInfo();
    this.syncViewport();
  },

  mounted() {
    window.addEventListener("resize", this.syncViewport);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.syncViewport);
  },
};
</script>

<style>
html,
body,
#app {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  background-color: #F6F8FC;
}

#home {
  box-sizing: border-box;
  padding-top: 64px;
  width: 100%;
}

/* OAuth 路由无 header，不需要预留头部高度 */
#home.no-header {
  padding-top: 0;
}

/* 移动端：部分页面仍是 PC 定宽布局（min-width: 1280），会把布局视口撑宽，
   导致固定定位的头部随之变宽、右侧「搜索/头像/菜单」被挤出屏幕。
   这里把横向溢出收进 #home 内部滚动，使布局视口始终等于屏幕宽度，头部完整可见 */
@media (max-width: 767px) {
  #home:not(.no-header) {
    overflow-x: auto;
  }
}
</style>
